import React from "react";
import { connect } from "dva";
import { Tooltip, Button } from "antd";
import { router } from "umi";
import Container from "../../../../../components/Container";
import ListPage from "../../../../../components/ListPage";
import OperateDropdown from "../../../../../components/OperateDropdown";
import {
  getBureauNormSummary,
  getSchoolNormSummary
} from "../../../../../services/activitySign/dataStatistic/normSummary";
import { GetQueryString } from "../../../../../utils/utils";
import { getComposeUrl } from "../../../../../utils/common";
import useRequest from "../hooks/use-table-state";
import styles from "./index.less";

const { ListTable } = ListPage;

const NormSummary = props => {
  const appId = GetQueryString("appId") || 40;
  const activityBizId = GetQueryString("activityBizId");
  const { currentUser } = props;
  const { orgType } = currentUser || {};

  const { pageInfo, list, loading, handlePaginationChange } = useRequest(
    orgType === "school" ? getSchoolNormSummary : getBureauNormSummary,
    {
      initParams: {
        page: 1,
        pageSize: 10,
        activityBizId
      }
    }
  );

  const handleJump = record => {
    const { pathname } = window.location;
    const { indexName } = record;
    router.push(
      getComposeUrl(
        `${pathname}/normSummaryDetail?activityBizId=${activityBizId}&indexName=${indexName}&appId=${appId}`
      )
    );
  };

  const columns = [
    {
      title: "指标名称",
      dataIndex: "indexName",
      key: "indexName",
      width: 330,
      fixed: "left",
      render: activityName => (
        <Tooltip placement="top" title={activityName}>
          <span>
            {activityName.length <= 20
              ? activityName
              : `${activityName.substring(0, 20)}...`}
          </span>
        </Tooltip>
      )
    },
    {
      title: orgType === "school" ? "汇总部门/班级数" : "汇总组织数",
      dataIndex: "deptNumber",
      key: "deptNumber"
    },
    {
      title: "汇总指标量",
      dataIndex: "indexSum",
      key: "indexSum"
    },
    {
      title: "操作",
      key: "action",
      width: 120,
      fixed: "right",
      render: record => {
        const { indexSum } = record;
        const data = [
          {
            text: <a onClick={() => handleJump(record)}>详情</a>
          }
        ];
        return indexSum ? <OperateDropdown data={data} /> : "-";
      }
    }
  ];

  const containerProps = {
    breStates: 1,
    isPathParams: 1,
    defaultPadding: 1
  };

  const listPageProps = {
    spinProps: {
      spinning: loading
    }
  };

  const tableProps = {
    columns,
    list,
    pageInfo,
    onPageChange: handlePaginationChange
  };

  return (
    <Container {...containerProps}>
      <div className={styles.root}>
        <ListPage {...listPageProps}>
          {/* <Button type="primary">导出</Button> */}
          <ListTable {...tableProps} />
        </ListPage>
      </div>
    </Container>
  );
};

export default connect(({ user }) => ({
  ...user
}))(NormSummary);
